<input
  hidden
  (change)="onFileSelected_CargaMasivaAlertas()"
  #fileInput
  type="file"
  id="file"
/>
<div class="bx-toolbar" data-tour="bandeja.buscador">
  <div class="bx-title">
    <h3>{{ view == "Case" ? "Casos" : "Alertas" }}</h3>
    <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
  </div>
  <div class="bx-search">
    <mat-icon class="bx-search__icon">search</mat-icon>
    <input
      [(ngModel)]="search"
      (keyup.enter)="filterData()"
      type="text"
      [placeholder]="view == 'Case' ? 'Buscar casos (Enter)' : 'Buscar alertas (Enter)'"
      aria-label="Buscar"
    />
    <button
      *ngIf="search"
      mat-icon-button
      class="bx-search__clear"
      aria-label="Limpiar búsqueda"
      (click)="search = ''; filterData()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <button
    mat-stroked-button
    type="button"
    class="bx-filter-btn"
    [class.bx-filter-btn--on]="searchTouch"
    (click)="searchTouch = !searchTouch"
  >
    <mat-icon>tune</mat-icon>
    Filtros
    <span class="bx-count" *ngIf="filtrosActivos">{{ filtrosActivos }}</span>
  </button>
  <span class="bx-spacer"></span>

    <div *ngIf="seeStrikes" class="buttons-filter">
      <button
        mat-raised-button
        class="primary-btn rounded btnStrike"
        (click)="goToStrikeUser()"
      >
        Strikes
      </button>
    </div>
    <div class="buttons-filter">
      <button
        mat-raised-button
        class="primary-btn rounded btnStrike"
        *ngIf="urgenteActive"
        [matMenuTriggerFor]="menu"
      >
        {{ opcionActual == "" ? "Todas" : opcionActual }}
        <mat-icon>filter_list</mat-icon>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="filterByOption({}, '')">Todas</button>
          <button mat-menu-item (click)="filterByOption({}, 'no Localizado')">
            Cliente no Localizado
          </button>
          <button
            *ngIf="canSee"
            mat-menu-item
            (click)="filterByOption({}, 'no atendidas')"
          >
            No atendidas
          </button>
          <button mat-menu-item (click)="filterByOption({}, 'confirmadas')">
            Confirmadas
          </button>
          <button mat-menu-item (click)="filterByOption({}, 'Rechazada')">
            Rechazada
          </button>
          <button
            mat-menu-item
            (click)="filterByOption({}, 'Rechazada con cuenta')"
          >
            Rechazada Condicionada
          </button>
        </mat-menu>
      </button>
    </div>
    <div class="buttons-filter">
      <button class="primary-btn rounded btnStrike mat-raised-button" *ngIf="isGerente"
        (click)="irALaVistaReportes()">
        Reportes
      </button>
    </div>
</div>
<filter-cases-new-view
  #filterCasesNewView
  [view]="view"
  [users]="users"
  [open]="searchTouch"
  (sendToHeaderSearch)="filterData($event)"
></filter-cases-new-view>
